import React, { Fragment } from "react";
import { withData } from "../common/WithData";
import { DictionaryControl } from "../components/DictionaryControl";
import StudentController from "../api/StudentController";
import AddressesView from "../components/AddressesView";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import DateRenderer from "../components/renderers/DateRenderer";
import StringArrayRenderer from "../components/renderers/StringArrayRenderer";
import ErrorBoundary from "./ErrorBoundry";
import EmailRenderer from "../components/renderers/EmailRenderer";
import NormalRendererPhone from "../components/renderers/NormalRendererPhone";

class AboutStudent extends React.Component 
{
    studentController: StudentController;

    constructor(props: any) 
    {
        super(props);

        this.studentController = new StudentController();
    }

    render(): React.ReactNode 
    {
        const items = [];
        const itemsDegree = [];

        items.push(
            {
                keys: ["email"],
                renderer: EmailRenderer
            });

        items.push(
            {
                keys: ["phoneNumbers"],
                renderer: NormalRendererPhone
            });

        items.push({
            keys: "dob",
            renderer: DateRenderer
        });

        itemsDegree.push({
            keys: ["primaryMajors", "secondaryMajors", "minors", "ultimateDegree"],
            renderer: StringArrayRenderer
        });

        const ignores = ["userId", "suppressionFlag"];

        //Hide previous school 
        if (this.props.settings.length > 0)
        {
            if (this.props.role == "academicAdvisor" && this.props.settings.filter(itm => itm.settingId == "psAcademicPrevSchool")[0].isActive == true)
                ignores.push("previousSchool");
        }

        const BiographicsData = withData(
            DictionaryControl,
            "Biographic information",
            async () => await this.studentController.getBiographics()
        );

        const DegreeData = withData(
            DictionaryControl,
            "Degree",
            async () => await this.studentController.getDegree()
        );

        const AddressViewData = withData(
            AddressesView,
            "Addresses",
            async () => await this.studentController.getAddresses()
        );

        const biographyMap = { mitId: "MIT ID", dob: "Date of birth" };

        return <Fragment>
            <ErrorBoundary>
                <Row>
                    <Col lg={6} className="right-border">
                        <h2>Biographic Information</h2>
                        <BiographicsData maps={biographyMap} role={this.props.role} renderers={items} ignores={ignores} />
                    </Col>
                    <Col lg={6}>
                        <div style={{ marginBottom: 40 + "px" }}>
                            <h2>Degree Information</h2>
                            <DegreeData ignores={ignores} renderers={itemsDegree} />
                        </div>

                        <h2>Address Information</h2>
                        <AddressViewData />
                    </Col>
                </Row>
            </ErrorBoundary>
        </Fragment>;
    }
}

const mapStateToProps = (state: any) => ({
    student: state.student.activeStudent,
    role: state.app.user.role,
    settings: state.app.privacySettings
});

export default connect(mapStateToProps)(AboutStudent);